import { AxiosInstance } from 'axios';
import { ServiceBaseConfig } from './Interfaces/IAccountService';
import { ICompanyFolders, UploadDocumentInput } from './Interfaces/IFolderService';

export class BillingService {

  public static async getCompaniesPayments(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<ICompanyFolders> {
    const response = await api.get('/companies/billing/payments', config);
    return response.data.data.data;
  }

  public static async getCompaniesPaymentStatus(
    api: AxiosInstance,
    config: ServiceBaseConfig,
    page: number
  ): Promise<any> {
    const response = await api.get(`/agent/companies/billing?page=${page}`, config);
    return response.data;
  }

  /* Tirar dúvida com o Jean */
  public static async companiesBillingPayments(
    api: AxiosInstance,
    documents: UploadDocumentInput[],
    config: ServiceBaseConfig
  ): Promise<any> {
    const formData = new FormData();

    documents.forEach((doc, index) => {
      formData.append(`documents[${index}][company_id]`, String(doc.company_id));
      formData.append(`documents[${index}][template]`, doc.template);
      formData.append(`documents[${index}][document]`, doc.document);
      formData.append(`documents[${index}][customer_can_view]`, String(+doc.customer_can_view));
      formData.append(`documents[${index}][customer_can_manage]`, String(+doc.customer_can_manage));
      formData.append(`documents[${index}][requires_signature ]`, '0');
      
      if (doc.issue_date) {
        formData.append(`documents[${index}][issue_date]`, String(doc.issue_date))
      }

      if (doc.document_template_alias) 
        formData.append(`documents[${index}][document_template_alias]`, doc.document_template_alias);
     

      if (doc.user_id)
        formData.append(`documents[${index}][user_id]`, String(doc.user_id));
      
    });

    const { data } = await api.post('/companies/billing/payments', formData, {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  }

  public static async changeDueDateAnnualFee(
    api: AxiosInstance,
    payload: {
      due_date: string
      jurisdiction_id: number
    },
    config: ServiceBaseConfig
  ): Promise<any> {

    const { data } = await api.put('/companies/billing/annual-fee', payload, {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  }

  public static async getAnnualFeeConfigs(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<any> {
    const response = await api.get('/instances/billing/annual-fee', config);
    return response.data?.data?.data || [];
  }

  public static async updateAnnualFeeConfig(
    api: AxiosInstance,
    payload: {
      company_type: string;
      jurisdiction_id: number;
      amount?: number | string;
      due_date?: string;
      description?: string;
    },
    config: ServiceBaseConfig
  ): Promise<any> {
    const response = await api.put('/instances/billing/annual-fee', payload, config);
    return response.data;
  }

  public static async getLatestAnnualFee(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<any> {
    const response = await api.get('/companies/billing/annual-fees/latest', config);
    return response.data;
  }

  public static async getAnnualFeeCorporateDirector(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<any> {
    const response = await api.get('/companies/billing/annual-fees/latest', config);
    return response.data;
  }
}
